/*
to reuse confirmation dialog just connect(mapState, mapDispatch) with the locaIds and onClose and onConfirmation click..
copy/paste code below to your confirmationDialog.tsx

const mapState = (): IDialogConfirmationState => ({
    messageLocaId: IdLoca.bodyLocaId
    primaryBtnLocaId: IdLoca.confirmBtnLocaId
    titleLocaId: IdLoca.titleLocaId
});

const mapDispatch = (dispatch: Dispatch): IDialogConfirmationDispatch => ({
    onClose: () => dispatch(actionModalClose(IdModal.yourDialiog)),
    onConfirmation: () => dispatch(...),
});

export const DialogName = connect(
    mapState,
    mapDispatch,
)(DialogConfirmation);

 */
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { DialogContent } from "../../errors/DialogContent";
import { ButtonDelete } from "../common/ButtonDelete";
import { ButtonPrimary } from "../common/ButtonPrimary";
import { TextLoca } from "../text/TextLoca";
export var DialogConfirmation = function (_a) {
    var onClose = _a.onClose, primaryBtnLocaId = _a.primaryBtnLocaId, titleLocaId = _a.titleLocaId, messageLocaId = _a.messageLocaId, onConfirmation = _a.onConfirmation;
    return (React.createElement(DialogWrapper, { titleLocaId: titleLocaId, className: IdStyles.ModalBackgroundInfo, onClose: onClose },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: messageLocaId }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonDelete, { onClick: onClose },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
                React.createElement(ButtonPrimary, { onClick: onConfirmation },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: primaryBtnLocaId }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/dialog-confirmation/DialogConfirmation.tsx
// module id = 597
// module chunks = 3